import React from 'react'
import { Navigate } from 'react-router-dom';

function ProtectedRouter({children}) {

    if (localStorage.getItem('token')!=null) {
        
        return children;
    }
    else{
        return <Navigate to={'/login'}></Navigate>
    }
 
}

export default ProtectedRouter
